import BaseService from './baseService';

class DiscussionService {

    static getDiscussionSections() {
        return BaseService.getAndReturn('/Discussions', BaseService.returnAssignedArray, 'Unable to get discussions', true);
    }

    static getDiscussions(sectionLink, page = 1) {
        return BaseService.getAndReturn(`/Discussions/${sectionLink}?page=${page}`, BaseService.returnAssignedObject, 'Unable to get discussions', true);
    }

    static addDiscussion(sectionLink, discussion) {
        return BaseService.postAndReturn(`/Discussions/${sectionLink}`, discussion, BaseService.returnAssignedObject, null, true);
    }

    static getPosts(sectionLink, discussionLink, page = 1, currentProfileID = null) {
        return BaseService.getAndReturn(`/Discussions/${sectionLink}/${discussionLink}?page=${page}&currentProfileID=${currentProfileID}`, BaseService.returnAssignedObject, 'Unable to get posts', true);
    }

    static addPost(sectionLink, discussionLink, newPost) {
        return BaseService.postAndReturn(`/Discussions/${sectionLink}/${discussionLink}`, newPost, BaseService.returnAssignedObject, null, true);
    }

    static reportPost(postID, reportType, currentProfileID) {
        return BaseService.postAndReturn(`/Discussions/Posts/${postID}/Reports?reportType=${reportType}&currentProfileID=${currentProfileID}`, null, (data) => data, null, true);
    }

    static deleteReportPost(postID, currentProfileID) {
        return BaseService.deleteAndReturn(`/Discussions/Posts/${postID}/Reports?currentProfileID=${currentProfileID}`, (data) => data, null, true);
    }
}

export default DiscussionService